import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommunicationProxyService } from '../../../services/communication-proxy.service';
import { LoginService } from '../../../services/login.service';
import { StringTableService } from '../../../services/string-table.service';
import { PageViewComponent } from '../../page-view/page-view.component';
import { activeTrainingPageEnum, TrainingManagementComponent } from '../training-management/training-management.component';

@Component({
  selector: 'app-training-management-home',
  templateUrl: './training-management-home.component.html',
  styleUrls: ['./training-management-home.component.scss']
})

export class TrainingManagementHomeComponent extends PageViewComponent implements OnInit {
  selectedIndex: number;
  pageTitle: string;
  public trainingManagementMenuData: any = null;

  @Output() selectedIndexChanged: EventEmitter<object> = new EventEmitter();
  @ViewChild('menuBlock') menuBlock;

  appLinks = [
    '/create-autotraining',
    '/inactive-autotraining',
    '/email-invite',
    '/email-sent',
    '/reporting'
  ];


  constructor(ele: ElementRef, stringTableService: StringTableService,
    remoteProxy: CommunicationProxyService, protected loginService: LoginService,
    protected cdr: ChangeDetectorRef,
    protected router: Router,
  ) {
    super(ele, remoteProxy, loginService, stringTableService, router);
    this.appLinks.push(this.stringTableService.getString('externalLinks', 'origin'));
  }

  ngOnInit() {
    TrainingManagementComponent.setActiveTrainingPage(activeTrainingPageEnum.trainingManagementHome);
    this.trainingManagementMenuData = this.stringTableService.getTrainingManagementMenuData();
    this.pageTitle = this.stringTableService.getString('trainingManagementHome', 'pageTitle');
    this.cdr.detectChanges();
    this.menuBlock.blocks.nativeElement.focus();
  }

  onClick(event) {
    this.selectedIndex = event.index;
    this.selectedIndexChanged.emit({ index: this.selectedIndex, event: 'selectedIndexChanged' });
  }

}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/training-management/training-management-home/training-management-home.component.ts